<template>
  <div class="not_found">
    <h1 class="title">Page Not Found</h1>
    <p class="subtitle">The page you're looking for doesn't exist.</p>
    <base-button @click="goHome" mode="primary">Go to Dashboard</base-button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from '@/composables/core/useRouter';

export default defineComponent({
  name: 'NotFound',
  setup() {
    const router = useRouter();

    const goHome = () => {
      router.push('/dashboard');
    };

    return {
      goHome
    };
  }
});
</script>

<style scoped>
.not_found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  padding: var(--spacing-8);                    /* was: 2rem */
}

.title {
  font-size: 3rem;                              /* Intentionally large for error page */
  font-weight: var(--font-weight-bold);         /* was: 700 */
  color: var(--color-text-primary);             /* was: #2c3e50 */
  margin-bottom: var(--spacing-4);              /* was: 1rem */
}

.subtitle {
  font-size: var(--font-size-lg);               /* was: 1.25rem */
  color: var(--color-text-secondary);           /* was: #6c757d */
  margin-bottom: var(--spacing-8);              /* was: 2rem */
}
</style>
